// Expand / Collapse Footer
const { $, feather } = window;

$(() => {
  $('.footer .header-row').on('click', function callback() {
    if ($(window).width() < 992) {
      const $this = $(this);
      $this.next('ul').slideToggle();
      const $chevronContainer = $this.find('.arrow-link');

      if ($chevronContainer.find('svg').hasClass('feather-chevron-down')) {
        $chevronContainer.html(feather.icons['chevron-up'].toSvg());
      } else {
        $chevronContainer.html(feather.icons['chevron-down'].toSvg());
      }
    }
  });
});
